module.exports = __webpack_public_path__ + "static/mystra-symbol-SCAG-cb444c7f61175671b26b267e09bd636e.png";